import { IconButton } from '@bolteu/clay-react';
import { useBreakpointUp } from '@provider-portal/design-common/clay/hooks/useBreakpoint';

import { Burger } from '@bolteu/kalep-react-icons';

import {
  NavBarVenueSelector,
  NavBarVenueSelectorProps,
} from 'components/merchant-portal-2/NavBar/NavBarVenueSelector';

export interface NavBarHeaderProps {
  drawerWidth: number;
  venueSelector: NavBarVenueSelectorProps;
  onHandleDrawerToggle?: () => void;
  onSelectorOpen?: () => void;
  onSearchPerformed?: (searchQuery: string, resultsCount: number, searchCount: number) => void;
}

export function NavBarHeader({
  venueSelector,
  onHandleDrawerToggle,
  onSelectorOpen,
  onSearchPerformed,
}: NavBarHeaderProps) {
  const isMobileView = !useBreakpointUp('md');

  const handleDrawerToggle = () => {
    if (onHandleDrawerToggle) {
      onHandleDrawerToggle();
    }
  };

  if (!isMobileView) {
    return null;
  }

  return (
    <header className="fixed top-0 right-0 z-[1100] flex w-full shrink-0 flex-col bg-layer-floor-1 text-primary">
      <div className="relative flex items-center p-2 max-sm:min-h-14 landscape:max-sm:min-h-12 sm:min-h-16">
        <div className="flex w-full items-center justify-between">
          <IconButton
            aria-label="open menu"
            variant="ghost"
            size="sm"
            className="mr-4 size-10 [&_svg]:size-6"
            onClick={handleDrawerToggle}
            icon={<Burger />}
          />
          <NavBarVenueSelector
            parentName={venueSelector.parentName}
            storeName={venueSelector.storeName}
            selectedStoreId={venueSelector.selectedStoreId}
            stores={venueSelector.stores}
            storeAvailabilities={venueSelector.storeAvailabilities}
            storeAvailabilitiesLoading={venueSelector.storeAvailabilitiesLoading}
            onProviderSelect={venueSelector.onProviderSelect}
            showAddVenueButton={venueSelector.showAddVenueButton}
            onAddVenue={venueSelector.onAddVenue}
            onSelectorOpen={onSelectorOpen}
            onSearchPerformed={onSearchPerformed}
          />
        </div>
      </div>
    </header>
  );
}
